import { filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { SymbolSyntheticAction } from '@cbridge-packages/symbol-synthetic';

export const handleSyntheticSymbolNotFoundEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.load.failed),
  filter(({ error }) => error.status === 404),
  map(() => DetailsSidebarAction.close()),
);
